import { render, staticRenderFns } from "./MyClasses.vue?vue&type=template&id=4752de85&scoped=true&"
import script from "./MyClasses.vue?vue&type=script&lang=js&"
export * from "./MyClasses.vue?vue&type=script&lang=js&"
import style0 from "./MyClasses.vue?vue&type=style&index=0&id=4752de85&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4752de85",
  null
  
)

export default component.exports